import baseRequest from "../_core/baseRequest";

export default {
    listAutocompleteAddresses: params => baseRequest.post("/location/autocomplete", params),
    getLocationDetail: params => baseRequest.get(`/location/${params.placeId}`)
};
